import Vue from 'vue';
import Router from 'vue-router';
import store from './../store';
import Home from '@/views/Home';
import Login from '@/views/Login';
import MitarbeiterUebersicht from '@/views/mitarbeiter/MitarbeiterUebersicht'
import MitarbeiterFormular from '@/views/mitarbeiter/MitarbeiterFormular'
import FragebogenVorschau from '@/views/fragebogen/FragebogenVorschau'
import FragebogenZwischenstandUebersicht from '@/views/fragebogen/FragebogenZwischenstandUebersicht'
import FragebogenAusfuellerSicht from '@/views/fragebogen/FragebogenAusfuellerSicht'
import ProjektUebersicht from "@/views/projekt/ProjektUebersicht";
import ProjektDetailansicht from "@/views/projekt/ProjektDetailansicht";
import Datenimport from "@/views/Datenimport";
import Auswertungen from "@/views/Auswertungen";
import TemplateUebersicht from "@/views/templates/TemplateUebersicht";
import TemplateFormular from "@/views/templates/TemplateFormular";
import SeiteNichtGefunden from '@/views/404';

import { isAuthenticated } from '@/auth';
import PasswortAendern from "@/views/PasswortAendern";
import Profil from "@/views/Profil";

Vue.use(Router);

const checkAuthenticated = (to, from, next) => {
  if (isAuthenticated()) {
    var userData = store.getters['userData/getUserData'];
    const { authorize } = to.meta;
    if (authorize) {
      if (authorize.length && !authorize.includes(userData.rolle)) {
        next('/')
      } else {
        next()
      }
    } else {
      next()
    }
  }
  else {
    if (to.name === 'fragebogenAusfuellen') {
      next()
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } });
    }
  }
}

const checkNotAuthenticated = (to, from, next) => {
  if (!isAuthenticated()) {
    next()
  } else {
    next('/home')
  }
};

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: true,
    beforeEnter: checkNotAuthenticated
  },
  {
    path: '/passwortAendern',
    name: 'passwortAendern',
    component: PasswortAendern,
    props: true,
  },
  {
    path: '/profil',
    name: 'profil',
    component: Profil,
    props: true,
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/projekt',
    name: 'projektUebersicht',
    component: ProjektUebersicht,
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/projekt/:uuid',
    name: 'projektDetailAnsicht',
    component: ProjektDetailansicht,
    props: true,
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/fragebogenVorschau/:uuid?',
    name: 'fragebogenVorschau',
    component: FragebogenVorschau,
    props: true,
    beforeEnter(to, from, next) {
       checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/fragebogenAusfuellen/:uuid?',
    name: 'fragebogenAusfuellen',
    component: FragebogenAusfuellerSicht,
    props: true,
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/fragebogenZwischenstandUebersicht/uuid/:uuid?/position/:position?/aktuell/:aktuell',
    name: 'fragebogenZwischenstandUebersicht',
    component: FragebogenZwischenstandUebersicht,
    props: true,
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/auswertungen',
    name: 'Auswertungen',
    component: Auswertungen,
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/templates',
    name: 'Templates',
    component: TemplateUebersicht,
    meta: { authorize: ['ADMINISTRATOR'] },
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/template/:uuid',
    name: 'TemplateFormular',
    component: TemplateFormular,
    meta: { authorize: ['ADMINISTRATOR'] },
    props: true,
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/templateNeu',
    name: 'TemplateFormular',
    component: TemplateFormular,
    meta: { authorize: ['ADMINISTRATOR'] },
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/datenimport',
    name: 'Datenimport',
    component: Datenimport,
    meta: { authorize: ['ADMINISTRATOR'] },
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/mitarbeiter',
    name: 'Mitarbeiter',
    component: MitarbeiterUebersicht,
    meta: { authorize: ['ADMINISTRATOR'] },
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/mitarbeiter/:uuid',
    name: 'MitarbeiterFormular',
    component: MitarbeiterFormular,
    meta: { authorize: ['ADMINISTRATOR'] },
    props: true,
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '/mitarbeiterNeu',
    name: 'MitarbeiterFormular',
    component: MitarbeiterFormular,
    meta: { authorize: ['ADMINISTRATOR'] },
    beforeEnter(to, from, next) {
      checkAuthenticated(to, from, next);
    }
  },
  {
    path: '*',
    component: SeiteNichtGefunden
  },
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
